import { useSyncExternalStore } from 'react';
import { getLegKickUiSnapshot, subscribeLegKickUi } from '../../state/legKickUiStore.ts';
import { LEG_KICK_DOM } from './legKickDomIds.ts';
import { useI18n } from 'shared/lib/i18n.tsx';

export function LegKickPause() {
  const d = LEG_KICK_DOM;
  const { t } = useI18n();
  const s = useSyncExternalStore(
    subscribeLegKickUi,
    getLegKickUiSnapshot,
    getLegKickUiSnapshot,
  );

  const pauseBody =
    s.pauseSplit && s.pauseP1 !== null && s.pauseP2 !== null
      ? `${s.pauseP1} : ${s.pauseP2}`
      : String(s.pauseScoreSingle);

  return (
    <div
      id={d.pauseRoot}
      className="leg-kick-pause"
      hidden={!s.pauseVisible}
      role="dialog"
      aria-modal="true"
      aria-labelledby={d.pauseTitle}
    >
      <div className="leg-kick-pause__panel">
        <h2 id={d.pauseTitle} className="leg-kick-pause__title">
          {t('game.pause')}
        </h2>
        <div className="leg-kick-pause__score">{pauseBody}</div>
      </div>
    </div>
  );
}
